/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import * as fromDesignTokens from 'Simple/DesignTokens'
import AddAction from './AddAction/index'
import React from 'react'
import TableX from 'DesignSystem/TableX/react'
import TysiaHeading from 'DesignSystem/TysiaHeading/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content",
  tableData
  
}) {
let dtSpaceL = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.l'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-Z1Yf8zk': typeof dtSpaceL === 'number' ? `${dtSpaceL}px` : dtSpaceL}}
 className={`views-block ${styles.Horizontal}`}
>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<TysiaHeading
  viewPath={`${viewPath}/TysiaHeading`}
 text="Connections"
 level="h2"
/>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="Add account connections, configure automations, and sync patients for locations."
 color={dtColorsNeutral500}
/>
</div>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
<TableX
  viewPath={`${viewPath}/TableX`}
 value={tableData}
 overflow="visible"
 backgroundColorRow="transparent"
 backgroundColorRowSelected="transparent"
 borderBottomWidthCell={1}
 borderBottomStyleCell="solid"
 borderBottomColorCell={dtColorsNeutral200}
 paddingBottomCell={dtSpaceS}
 paddingTopCell={dtSpaceS}
 borderBottomWidthHeader={1}
 backgroundColorHeader="transparent"
 borderBottomStyleHeader="solid"
 borderBottomColorHeader={dtColorsNeutral200}
 paddingBottomHeader={dtSpaceXs}
 borderLeftWidthHeader={0}
 borderLeftStyleHeader="none"
 borderLeftColorHeader="transparent"
 borderColor="transparent"
 borderRadius={0}
 borderStyle="none"
 borderWidth={0}
 colorRow="transparent"
 cursorHeader="pointer"
 fontFamily="Inter"
 fontSize={12}
 fontWeight={400}
 fontWeightHeader={500}
 heightHeader={45}
 heightRow={76}
 marginBottom={0}
 marginLeft={0}
 marginRight={0}
 marginTop={dtSpaceXs}
 paddingLeftCell={0}
 paddingLeftHeader={0}
 paddingRightCell={0}
 paddingRightHeader={0}
/>
{children}
</React.Fragment>)
}